export default __webpack_public_path__ + "static/media/BlueCard.1ce277b3.png";